// quiz-logic.js
// Globale Namespace-Vorbereitung
window.CatQuiz = window.CatQuiz || {};

CatQuiz.logic = (function(config, data) {
  "use strict";

  const { IDEAL_WEIGHTS = {} } = config || {};

  const IDEAL_WEIGHT_BREED_ALIASES = {
    "Europäisch Kurzhaar (Mischling)": "Europäische Hauskatze (Mischling)",
    "Europäisch Kurzhaar oder Mischling": "Europäische Hauskatze (Mischling)",
    "Mischling": "Europäische Hauskatze (Mischling)",
    "Karthäuser": "Karthäuser (Chartreux)"
  };
// =====================================================
// Modal Meta (UI only) – KEINE Nährwert-Duplikate
// =====================================================
CatQuiz.data.MODAL_META = {
  huhn: {
    title: "Katzenliebe Huhn:"
  },
  huhnForelle: {
    title: "Katzenliebe Huhn-Forelle:",
    headerRight: "Fütterungsempfehlung"
  }
};

  // --------------------------------------------------
  // Metabolisierbare Energie (ME) berechnen
  // --------------------------------------------------
  function calcME({ protein, fat, ash, fiber, moisture }) {
    // NFE (Stickstofffreie Extraktstoffe) überschlägig
    const nfe = 100 - (protein + fat + ash + fiber + moisture);

    // Bruttoenergie (GE) nach Atwater-Faktoren (angepasst)
    const GE =
      5.7 * (protein / 100) +
      9.4 * (fat / 100) +
      4.1 * ((nfe + fiber) / 100);

    // Verdaulichkeit (vereinfachtes Modell)
    const digestibility =
      87.9 - (0.88 * (fiber / (100 - moisture)) * 100);

    const DE = GE * (digestibility / 100);    // Verdauliche Energie
    const ME = DE - (0.77 * (protein / 100)); // Metabolisierbare Energie
    return ME; // kcal pro Gramm Futter
  }


  const FOOD_CATALOG = Array.isArray(config?.FOOD_CATALOG) ? config.FOOD_CATALOG : [];

  function normalizeFoodCode(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }

  function normalizeAllergenTag(value) {
    return normalizeFoodCode(value);
  }

  function getActiveCatalogFoods() {
    return FOOD_CATALOG
      .filter((food) => food && food.code && food.isActive !== false)
      .slice()
      .sort((a, b) => Number(a?.sortOrder || 0) - Number(b?.sortOrder || 0));
  }

  function getFoodAnalytics(food) {
    const src = food?.analytics || {};
    return {
      protein: Number(src.protein),
      fat: Number(src.fat),
      ash: Number(src.ash),
      fiber: Number(src.fiber),
      moisture: Number(src.moisture),
    };
  }


  function foodMatchesKey(food, ...candidates) {
    const keys = [food?.code, food?.uiKey].map(normalizeFoodCode).filter(Boolean);
    const wanted = candidates.map(normalizeFoodCode).filter(Boolean);
    return wanted.some((candidate) => keys.includes(candidate));
  }

  function getFoodFromListByKey(foods, ...candidates) {
    return (Array.isArray(foods) ? foods : []).find((food) => foodMatchesKey(food, ...candidates)) || null;
  }

  function buildLegacyAliasesFromFoods(foods) {
    const huhn = getFoodFromListByKey(foods, "huhn");
    const huhnForelle = getFoodFromListByKey(foods, "huhn_forelle", "huhnForelle");

    return {
      shareHuhn: Number(huhn?.share || 0) || 0,
      shareHuhnForelle: Number(huhnForelle?.share || 0) || 0,
      gramsPerDayHuhn: Number(huhn?.gramsPerDay || 0) || 0,
      gramsPerDayHuhnForelle: Number(huhnForelle?.gramsPerDay || 0) || 0,
      gramsPerDayRind: 0,
      gramsHuhn: Number(huhn?.grams || 0) || 0,
      gramsHuhnForelle: Number(huhnForelle?.grams || 0) || 0,
      gramsRind: 0,
      unitsHuhn100g: Number(huhn?.units || 0) || 0,
      unitsHuhnForelle100g: Number(huhnForelle?.units || 0) || 0,
    };
  }

  function applyLegacyGramOverrides(base, foods) {
    let nextFoods = Array.isArray(foods) ? foods.slice() : [];

    const overrideDefs = [
      { candidates: ["huhn"], gramsPerDay: Number(base?.gramsPerDayHuhn), catalogCode: "huhn" },
      { candidates: ["huhn_forelle", "huhnForelle"], gramsPerDay: Number(base?.gramsPerDayHuhnForelle ?? base?.gramsPerDayRind), catalogCode: "huhn_forelle" },
    ];

    overrideDefs.forEach(({ candidates, gramsPerDay, catalogCode }) => {
      if (!Number.isFinite(gramsPerDay)) return;
      const idx = nextFoods.findIndex((food) => foodMatchesKey(food, ...candidates));
      if (idx >= 0) {
        nextFoods[idx] = {
          ...nextFoods[idx],
          gramsPerDay,
        };
        return;
      }

      if (gramsPerDay <= 0) return;

      const catalogFood = getFoodFromListByKey(FOOD_CATALOG, catalogCode);
      if (!catalogFood) return;

      nextFoods.push(buildComputedFood(catalogFood, {
        meKcalPerG: computeFoodMe(catalogFood),
        share: 0,
        gramsPerDay,
      }));
    });

    return nextFoods;
  }

  function computeFoodMe(food) {
    const analytics = getFoodAnalytics(food);
    if (Object.values(analytics).some((v) => !Number.isFinite(v))) return NaN;
    return calcME(analytics);
  }

  function buildComputedFood(food, values = {}) {
    const meKcalPerG = Number(values.meKcalPerG);
    return {
      code: String(food?.code || "").trim(),
      uiKey: food?.uiKey || null,
      label: food?.label || String(food?.code || "").trim(),
      variantId: food?.variantId ?? null,
      packSizeGrams: Number(food?.packSizeGrams || 100) || 100,
      allergenTags: Array.isArray(food?.allergenTags) ? food.allergenTags.slice() : [],
      analytics: getFoodAnalytics(food),
      meKcalPerG: Number.isFinite(meKcalPerG) ? meKcalPerG : NaN,
      share: Number(values.share || 0) || 0,
      gramsPerDay: Number(values.gramsPerDay || 0) || 0,
      grams: values.grams == null ? null : (Number(values.grams || 0) || 0),
      units: values.units == null ? null : (Number(values.units || 0) || 0),
    };
  }

  function getEligibleCatalogFoods(answers) {
    const allergyProteins = Array.isArray(answers?.allergyProteins) ? answers.allergyProteins.map(normalizeAllergenTag) : [];
    return getActiveCatalogFoods().filter((food) => {
      const tags = Array.isArray(food?.allergenTags) ? food.allergenTags.map(normalizeAllergenTag) : [];
      return !tags.some((tag) => allergyProteins.includes(tag));
    });
  }

  function computeEqualShares(count) {
    if (!Number.isFinite(count) || count <= 0) return [];
    const share = 1 / count;
    return Array.from({ length: count }, () => share);
  }

  // --------------------------------------------------
  // Basis-Futterplan für eine Katze
  // --------------------------------------------------
  function computeBasePlan(answers) {
    if (!answers) return null;

    const weight = Number(answers.weightKg || 0) || 0;
    const bcs = Number(answers.bcs || 3) || 3;
    const allergyProteins = Array.isArray(answers.allergyProteins) ? answers.allergyProteins : [];
    const allergicToHuhn = allergyProteins.includes("huhn");
    const allergicToFish = allergyProteins.includes("fisch");

    let kcal = 0;

    if (answers.isYoungCat) {
      const ageMonths = Number(answers.ageMonths || 0) || 0;
      const baseKcal = 100 * Math.pow(weight, 0.67);
      let factor;
      if (ageMonths <= 4) factor = 2.5;
      else if (ageMonths <= 9) factor = 2.0;
      else factor = 1.5;
      kcal = baseKcal * factor;
    } else if (bcs >= 4) {
      kcal = 130 * Math.pow(weight, 0.4);
    } else {
      const baseKcal = 100 * Math.pow(weight, 0.67);
      const neuterFactor = (answers.neuteredStatus === "kastriert") ? 0.95 : 1.0;
      const activityFactor = (answers.activity === "nicht_aktiv") ? 0.95 : 1.0;
      kcal = baseKcal * neuterFactor * activityFactor;
    }

    const eligibleFoods = getEligibleCatalogFoods(answers);
    if (!eligibleFoods.length) {
      return {
        error: "no_eligible_foods",
        kcal,
        allergicToHuhn,
        allergicToFish,
        foods: [],
        dailyGramsTotal: 0,
      };
    }

    const shares = computeEqualShares(eligibleFoods.length);
    const foods = eligibleFoods.map((food, index) => {
      const meKcalPerG = computeFoodMe(food);
      const share = shares[index] || 0;
      const gramsPerDay = Number.isFinite(meKcalPerG) && meKcalPerG > 0 ? (kcal * share) / meKcalPerG : 0;
      return buildComputedFood(food, {
        meKcalPerG,
        share,
        gramsPerDay,
      });
    }).filter((food) => food.code && Number(food.gramsPerDay || 0) > 0);

    const dailyGramsTotal = foods.reduce((sum, food) => sum + Number(food.gramsPerDay || 0), 0);
    const proteinPreference = foods.length === 1
      ? `nur_${foods[0].code}`
      : "gemischt";

    return {
      kcal,
      foods,
      dailyGramsTotal,
      allergicToHuhn,
      allergicToFish,
      proteinPreference,
      ...buildLegacyAliasesFromFoods(foods),
    };
  }

  // --------------------------------------------------
  // Futterplan über Lieferintervall (Dosen)
  // --------------------------------------------------
  function computeIntervalPlan(base, intervalDays) {
    const days = Number(intervalDays || 7) || 7;
    const foods = applyLegacyGramOverrides(base, Array.isArray(base?.foods) ? base.foods : [])
      .map((food) => {
        const packSizeGrams = Number(food?.packSizeGrams || 100) || 100;
        const gramsPerDay = Number(food?.gramsPerDay || 0) || 0;
        const grams = Math.round(gramsPerDay * days);
        const units = grams > 0 ? Math.ceil(grams / packSizeGrams) : 0;
        return {
          ...food,
          packSizeGrams,
          gramsPerDay,
          grams,
          units,
        };
      })
      .filter((food) => food.code && (food.grams > 0 || food.units > 0 || food.gramsPerDay > 0));

    const totalGrams = foods.reduce((sum, food) => sum + Number(food.grams || 0), 0);
    const totalUnits = foods.reduce((sum, food) => sum + Number(food.units || 0), 0);

    return {
      days,
      foods,
      totalGrams,
      totalUnits,
      ...buildLegacyAliasesFromFoods(foods),
    };
  }
  // --------------------------------------------------
  // Text-Bausteine für Gewicht / CTA im Ergebnis
  // --------------------------------------------------
  function getWeightTexts(bcs, name) {
    const displayName = name || "deine Katze";
    let title = "";
    let text  = "";
    let cta   = "";

    switch (bcs) {
      case 1:
      case 2:
        title = "Gewicht: eher zu leicht";
        text  = `${displayName} ist aktuell eher zierlich unterwegs. Das ist nicht schlimm – mit der richtigen Futtermenge kann ${displayName} langsam, aber gesund an Substanz gewinnen.`;
        cta   = `Mit deinem individuellen Futterkonzept hilfst du ${displayName}, Schritt für Schritt ein stabiles Wohlfühlgewicht zu erreichen.`;
        break;
      case 4:
        title = "Gewicht: ein bisschen zu viel des Guten";
        text  = `${displayName} bringt aktuell etwas mehr auf die Waage als optimal wäre. Das Gute: Schon kleine Anpassungen im Alltag machen hier einen großen Unterschied.`;
        cta   = `Mit dem abgestimmten Futterplan kannst du ${displayName} liebevoll beim Abnehmen begleiten – ohne Verzicht auf Genuss.`;
        break;
      case 5:
        title = "Gewicht: deutlich über dem Wohlfühlbereich";
        text  = `${displayName} ist deutlich über dem idealen Bereich. Das kann langfristig Gelenke, Organe und Lebensqualität beeinflussen – aber du hast jetzt die Chance gegenzusteuern.`;
        cta   = `Mit einem konsequent umgesetzten Futterplan kannst du ${displayName} Schritt für Schritt zurück in einen gesunden Bereich begleiten – für mehr Energie, Bewegungsfreude und Lebensqualität.`;
        break;
      case 3:
      default:
        title = "Gewicht: im Wohlfühlbereich";
        text  = `${displayName} liegt aktuell im schönen Wohlfühlbereich. Ziel ist es, dieses gesunde Gewicht langfristig zu halten – ohne Stress und ohne ständiges Rechnen.`;
        cta   = `Dein individuelles Futterkonzept hilft dir, ${displayName} dauerhaft ausgewogen und bedarfsgerecht zu versorgen.`;
        break;
    }

    return { title, text, cta };
  }

  function metabolicMassKg067(weightKg) {
    const w = Number(weightKg);
    if (!Number.isFinite(w) || w <= 0) return NaN;
    return Math.pow(w, 0.67);
  }

  function normalizeSexKey(sex) {
    const raw = String(sex || "").trim().toLowerCase();
    if (["female", "weiblich", "katze", "w", "f"].includes(raw)) return "female";
    if (["male", "männlich", "maennlich", "kater", "m"].includes(raw)) return "male";
    return "";
  }

  function normalizeIdealWeightBreedKey(breed) {
    const raw = String(breed || "").trim();
    if (!raw) return "";

    const aliased = IDEAL_WEIGHT_BREED_ALIASES[raw] || raw;
    if (IDEAL_WEIGHTS[aliased]) return aliased;

    const lower = aliased.toLowerCase();
    const exact = Object.keys(IDEAL_WEIGHTS).find((k) => String(k).toLowerCase() === lower);
    return exact || "";
  }

  function resolveIdealWeightKg({ breed, sex } = {}) {
    const breedKey = normalizeIdealWeightBreedKey(breed);
    const sexKey = normalizeSexKey(sex);
    if (!breedKey || !sexKey) return NaN;

    const weight = Number(IDEAL_WEIGHTS?.[breedKey]?.[sexKey]);
    return Number.isFinite(weight) && weight > 0 ? weight : NaN;
  }

  function calcMetabolicNeed(weightKg, factor) {
    const km067 = metabolicMassKg067(weightKg);
    const n = Number(factor);
    if (!Number.isFinite(km067) || !Number.isFinite(n)) return NaN;
    return km067 * n;
  }

  function calcProteinNeedGPerDay(weightKg) {
    const km067 = metabolicMassKg067(weightKg);
    if (!Number.isFinite(km067)) return NaN;
    return 7 * km067;
  }

  function calcTaurineMgPerDay(weightKg, currentFood) {
    const km067 = metabolicMassKg067(weightKg);
    if (!Number.isFinite(km067)) return NaN;

    const food = String(currentFood || "").toLowerCase();
    const isDry = food === "trockenfutter";
    const factorMg = isDry ? 24 : 42;
    return factorMg * km067;
  }

  function calcWaterMlPerDay(weightKg, waterMlPerKg = 50) {
    const w = Number(weightKg);
    const perKg = Number(waterMlPerKg);
    if (!Number.isFinite(w) || w <= 0) return NaN;
    if (!Number.isFinite(perKg) || perKg <= 0) return NaN;
    return w * perKg;
  }

  function calcFatNeedGPerDay(weightKg) {
    const km067 = metabolicMassKg067(weightKg);
    if (!Number.isFinite(km067)) return NaN;
    return 2.2 * km067;
  }

  function calcNfePercent({ protein, fat, ash, fiber, moisture }) {
    const p = Number(protein);
    const f = Number(fat);
    const a = Number(ash);
    const fi = Number(fiber);
    const m = Number(moisture);
    const vals = [p, f, a, fi, m];
    if (vals.some((v) => !Number.isFinite(v))) return NaN;
    return Math.max(0, 100 - (p + f + a + fi + m));
  }

  function calcNutrientIntakeGPerDay(gramsPerDay, percent) {
    const grams = Number(gramsPerDay);
    const pct = Number(percent);
    if (!Number.isFinite(grams) || grams < 0) return NaN;
    if (!Number.isFinite(pct) || pct < 0) return NaN;
    return grams * (pct / 100);
  }

  function calcWaterFromFoodMlPerDay(gramsPerDay, moisturePercent) {
    return calcNutrientIntakeGPerDay(gramsPerDay, moisturePercent);
  }

  function buildDailyNeeds({ weightKg, currentFood, waterMlPerKg = 50 } = {}) {
    return {
      proteinG: calcProteinNeedGPerDay(weightKg),
      taurineMg: calcTaurineMgPerDay(weightKg, currentFood),
      waterMl: calcWaterMlPerDay(weightKg, waterMlPerKg),
    };
  }

  function buildNutrientPlanMetrics({ weightKg, breed, sex } = {}) {
    const idealWeightKg = resolveIdealWeightKg({ breed, sex });

    return {
      idealWeightKg,
      proteinG: calcMetabolicNeed(weightKg, 32),
      arginineMg: calcMetabolicNeed(weightKg, 190),
      histidineMg: calcMetabolicNeed(weightKg, 64),
      isoleucineMg: calcMetabolicNeed(weightKg, 110),
      leucineMg: calcMetabolicNeed(weightKg, 250),
      lysineMg: calcMetabolicNeed(weightKg, 84),
      methionineMg: calcMetabolicNeed(weightKg, 42),
      methionineCystinMg: calcMetabolicNeed(weightKg, 84),
      phenylalanineMg: calcMetabolicNeed(weightKg, 99),
      phenylalanineTyrosinMg: calcMetabolicNeed(weightKg, 380),
      threonineMg: calcMetabolicNeed(weightKg, 130),
      tryptophanMg: calcMetabolicNeed(weightKg, 32),
      valineMg: calcMetabolicNeed(weightKg, 130),
      fatG: calcMetabolicNeed(weightKg, 2.2),
      linoleicAcidMg: calcMetabolicNeed(weightKg, 140),
      arachidonicAcidMg: calcMetabolicNeed(weightKg, 1.5),
      vitaminAIE: calcMetabolicNeed(weightKg, 82),
      vitaminDIE: calcMetabolicNeed(weightKg, 7),
      vitaminEMg: calcMetabolicNeed(weightKg, 0.9),
      thiaminUg: calcMetabolicNeed(weightKg, 140),
      riboflavinUg: calcMetabolicNeed(weightKg, 99),
      niacinUg: calcMetabolicNeed(weightKg, 990),
      pantothenicAcidUg: calcMetabolicNeed(weightKg, 140),
      pyridoxineUg: calcMetabolicNeed(weightKg, 60),
      biotinUg: calcMetabolicNeed(weightKg, 1.9),
      folicAcidUg: calcMetabolicNeed(weightKg, 19),
      cobalaminUg: calcMetabolicNeed(weightKg, 0.56),
      calciumMg: calcMetabolicNeed(weightKg, 71),
      phosphorusMg: calcMetabolicNeed(weightKg, 63),
      magnesiumMg: calcMetabolicNeed(weightKg, 10),
      sodiumMg: calcMetabolicNeed(weightKg, 17),
      potassiumMg: calcMetabolicNeed(weightKg, 130),
      chlorideMg: calcMetabolicNeed(weightKg, 24),
      ironMg: calcMetabolicNeed(weightKg, 2),
      copperMg: calcMetabolicNeed(weightKg, 0.1),
      zincMg: calcMetabolicNeed(weightKg, 1.9),
      manganeseMg: calcMetabolicNeed(weightKg, 0.11),
      iodineUg: calcMetabolicNeed(weightKg, 35),
      seleniumUg: calcMetabolicNeed(weightKg, 7)
    };
  }

  function buildFoodCollectionHealthMetrics({
    weightKg,
    bcs,
    currentFood,
    foods,
    waterMlPerKg = 40,
    taurineMgPerKg = 50,
  } = {}) {
    const items = Array.isArray(foods) ? foods : [];
    const weight = Number(weightKg);
    const dailyNeeds = buildDailyNeeds({ weightKg: weight, currentFood, waterMlPerKg });
    const taurinePerKg = Number(taurineMgPerKg);
    const taurineNeedMg = Number.isFinite(weight) && weight > 0 && Number.isFinite(taurinePerKg) && taurinePerKg > 0
      ? taurinePerKg * weight
      : NaN;

    const totals = items.reduce((acc, food) => {
      const grams = Number(food?.gramsPerDay || 0);
      const analytics = food?.analytics || {};
      const proteinPercent = Number(analytics.protein);
      const fatPercent = Number(analytics.fat);
      const ashPercent = Number(analytics.ash);
      const fiberPercent = Number(analytics.fiber);
      const moisturePercent = Number(analytics.moisture);
      const nfePercent = calcNfePercent({
        protein: proteinPercent,
        fat: fatPercent,
        ash: ashPercent,
        fiber: fiberPercent,
        moisture: moisturePercent,
      });
      acc.grams += Number.isFinite(grams) ? grams : 0;
      acc.protein += Number.isFinite(grams) && Number.isFinite(proteinPercent) ? calcNutrientIntakeGPerDay(grams, proteinPercent) : 0;
      acc.fat += Number.isFinite(grams) && Number.isFinite(fatPercent) ? calcNutrientIntakeGPerDay(grams, fatPercent) : 0;
      acc.carb += Number.isFinite(grams) && Number.isFinite(nfePercent) ? calcNutrientIntakeGPerDay(grams, nfePercent) : 0;
      acc.water += Number.isFinite(grams) && Number.isFinite(moisturePercent) ? calcWaterFromFoodMlPerDay(grams, moisturePercent) : 0;
      return acc;
    }, { grams: 0, protein: 0, fat: 0, carb: 0, water: 0 });

    return {
      proteinIntakeG: totals.protein,
      proteinNeedG: calcProteinNeedGPerDay(weight),
      fatIntakeG: totals.fat,
      fatNeedG: calcFatNeedGPerDay(weight),
      carbIntakeG: totals.carb,
      carbMaxG: Number.isFinite(weight) && weight > 0 ? 5 * weight : NaN,
      waterNeedMl: dailyNeeds.waterMl,
      waterFromFoodMl: totals.water,
      taurineNeedMg,
      playTimes: Number(bcs) >= 4 ? "3-5 mal à ca. 10 Min." : "2-3 mal à ca. 15 Min.",
    };
  }

  // Öffentliche API
  return {
    calcME,
    computeBasePlan,
    computeIntervalPlan,
    getWeightTexts,
    normalizeSexKey,
    normalizeIdealWeightBreedKey,
    resolveIdealWeightKg,
    metabolicMassKg067,
    calcMetabolicNeed,
    calcProteinNeedGPerDay,
    calcTaurineMgPerDay,
    calcWaterMlPerDay,
    calcFatNeedGPerDay,
    calcNfePercent,
    calcNutrientIntakeGPerDay,
    calcWaterFromFoodMlPerDay,
    buildDailyNeeds,
    buildNutrientPlanMetrics,
    buildFoodCollectionHealthMetrics,
    normalizeFoodCode
  };
})(CatQuiz.config, CatQuiz.data);